<template>
  <el-dialog v-model="dialogVisible" title="配置" @close="handleModalClose" width="1400px" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form ref="ruleForm" scroll-to-error class="rule-form" :model="form" label-position="right" label-width="170px">
      <div class="flex-box flex-box-ban" v-if="canViewAllConfig">
        <el-form-item label="收款禁用" prop="banPayment">
          <el-switch style="width: 186px" active-text="禁用" inactive-text="启用" :active-value="1" :inactive-value="0"
            v-model="form.banPayment" />
        </el-form-item>
        <el-form-item label="每日限额" prop="limitedDaily">
          <el-input v-model="form.limitedDaily" placeholder="每日限额"
            style="width: 186px"></el-input>
        </el-form-item>
      </div>
      <p class="sub-title" v-if="canViewFeeConfig">费率</p>
      <div class="flex-box flex-box-fee" v-if="canViewFeeConfig">
        <el-form-item label="支付费率" prop="paymentFeeRate" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input v-if="canEditAllConfig" v-model="form.paymentFeeRate" placeholder="请输入(小数, 0.02表示2%)"
            style="width: 186px" @input="value => handleDecimalInput(value, 'paymentFeeRate')"></el-input>
          <span v-else>{{ form.paymentFeeRate }}</span>
        </el-form-item>
        <el-form-item label="保证金比例" prop="depositRate" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input v-if="canEditAllConfig" v-model="form.depositRate" placeholder="请输入保证金比例"
            style="width: 186px" />
          <span v-else>{{ form.depositRate }}</span>
        </el-form-item>
        <el-form-item label="循环保证金天数" prop="revolvingMarginDays" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input-number v-if="canEditAllConfig" v-model="form.revolvingMarginDays" :min="0" :max="360"
            :step="1" placeholder="请输入循环保证金天数" style="width: 186px" />
          <span v-else>{{ form.revolvingMarginDays }}</span>
        </el-form-item>
      </div>
      <div class="flex-box flex-box-fee" v-if="canViewFeeConfig">
        <el-form-item label="成功交易服务费" prop="singleTradeFee" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input-number v-if="canEditAllConfig" v-model="form.singleTradeFee" :min="0" :max="100"
            :step="1" placeholder="请输入成功交易服务费" style="width: 186px" />
          <span v-else>{{ form.singleTradeFee }}</span>
        </el-form-item>
        <el-form-item label="失败交易服务费" prop="failSingleTradeFee" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input-number v-if="canEditAllConfig" v-model="form.failSingleTradeFee" :min="0" :max="100"
            :step="1" placeholder="请输入失败交易服务费" style="width: 186px" />
          <span v-else>{{ form.failSingleTradeFee }}</span>
        </el-form-item>
        <el-form-item label="拒付争议费(笔)" prop="chargebackFee" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input-number v-if="canEditAllConfig" v-model="form.chargebackFee" :min="0"
            :step="1" placeholder="请输入拒付争议费" style="width: 186px" />
          <span v-else>{{ form.chargebackFee }}</span>
        </el-form-item>
      </div>
       <div class="flex-box flex-box-fee" v-if="canViewFeeConfig">
         <el-form-item label="退款费用" prop="returnFeePer" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input-number v-if="canEditAllConfig" v-model="form.returnFeePer" :min="0" :max="100"
            :step="1" placeholder="请输入退款费用" style="width: 186px" />
          <span v-else>{{ form.returnFeePer }}</span>
        </el-form-item>
         <el-form-item label="提现手续费" prop="withdrawFeeRate" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input v-if="canEditAllConfig" v-model="form.withdrawFeeRate" placeholder="请输入(小数, 0.02表示2%)"
            style="width: 186px"></el-input>
          <span v-else>{{ form.withdrawFeeRate }}</span>
        </el-form-item>
        <el-form-item v-if="canEditAllConfig" label="退款时承担费率" prop="refundPaymentFeeRate" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input v-if="canEditAllConfig" v-model="form.refundPaymentFeeRate" placeholder="请输入(小数, 0.02表示2%)"
            style="width: 186px"></el-input>
          <span v-else>{{ form.refundPaymentFeeRate }}</span>
        </el-form-item>
       </div>
       <div class="flex-box flex-box-fee" v-if="canViewFeeConfig">
        <el-form-item v-if="canEditAllConfig" label="退款时保证金承担费率" prop="refundDepositRate" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input v-if="canEditAllConfig" v-model="form.refundDepositRate" placeholder="请输入(小数, 0.02表示2%)"
            style="width: 186px"></el-input>
          <span v-else>{{ form.refundDepositRate }}</span>
        </el-form-item>
       </div>
      <p class="sub-title" v-if="canViewAllConfig">结算</p>
      <div class="flex-box flex-box-settle" v-if="canViewAllConfig">
        <el-form-item label="结算日(T) " prop="settleDays" :rules="[
            {
              required: true,
              message: '请输入',
              trigger: ['blur', 'change'],
            },
          ]">
          <el-input-number v-if="canEditAllConfig" v-model="form.settleDays" :min="0" :max="100"
            :step="1" placeholder="请输入结算日" style="width: 186px" />
          <span v-else>{{ form.settleDays }}</span>
        </el-form-item>
        <el-form-item label="结算币种" prop="settleCurrency" :rules="[
          {
            required: true,
            message: '请选择结算币种',
            trigger: ['change'],
          },
        ]">
          <el-select v-model="form.settleCurrency" placeholder="请选择结算币种" no-data-text="暂无数据"
            style="width: 186px">
            <el-option v-for="item in data.settleCurrencyList" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="结算系数" prop="settleFactor" :rules="[
          {
            required: true,
            message: '请输入结算系数',
            trigger: ['blur'],
            // validator: checkFactor,
          },
        ]">
          <el-input
            v-model="form.settleFactor"
            placeholder="请输入结算系数"
            style="width: 186px"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flex-box flex-box-settle" v-if="canViewAllConfig">
        <el-form-item label="支付系数" prop="paymentFactor" :rules="[
          {
            required: true,
            message: '请输入支付系数',
            trigger: ['blur'],
          },
          {
            validator: checkPaymentFactor,
            trigger: ['blur', 'change'],
          },
        ]">
          <el-input
            v-model="form.paymentFactor"
            placeholder="请输入1到1.1之间的数字"
            style="width: 186px"
          ></el-input>
        </el-form-item>
        <el-form-item label="每周结算日" prop="settleWeek" class="settle-week-form-item" :rules="[
            {
              required: true,
              message: '请选择每周结算日',
              trigger: 'change',
            },
          ]">
          <el-select v-model="form.settleWeek" multiple placeholder="请选择每周结算日"
            style="width: 382px" class="settle-week-select">
            <el-option v-for="item in weekOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </div>
      <p class="sub-title"  v-if="canViewAllConfig">通道配置</p>
      <tm-table
        ref="tableRef"
        class="table-ref"
        :data="form.paymentSelectRules"
        :columns="data.columns"
        :hasSerialNumber="true"
         v-if="canViewAllConfig"
      >
        <template #countryCodes="{ item, rowInfo }">
          <el-form-item
            v-if="item.isEdit"
            :prop="'paymentSelectRules.' + rowInfo.index + '.countryCodes'" label=" " label-width="2px" :rules="rules.countryCodes">
            <el-select
              v-if="hasCountryTree"
              v-model="item.countryCodes"
              multiple
              filterable
              clearable
              collapse-tags
              collapse-tags-tooltip
              placeholder="全部"
              style="width: 100%;"
            >
              <el-option-group
                v-for="group in data.countryTree"
                :key="'country-group-' + group.value"
                :label="group.label"
              >
                <el-option
                  v-for="c in group.children || []"
                  :key="'country-' + c.value"
                  :label="c.label"
                  :value="c.value"
                />
              </el-option-group>
            </el-select>
            <el-select
              v-else
              v-model="item.countryCodes"
              multiple
              filterable
              clearable
              collapse-tags
              collapse-tags-tooltip
              placeholder="全部"
              style="width: 100%;">
              <el-option
                v-for="c in data.countries || []"
                :key="'country-fallback-' + (c.shortName || c.iso2 || c.value || c.name)"
                :label="c.name"
                :value="c.shortName"
              />
            </el-select>
          </el-form-item>
          <span v-else> {{ item.countryValue || '全部'}}</span>
        </template>
        <template #currencies="{ item, rowInfo }">
          <el-form-item
            v-if="item.isEdit"
            :prop="'paymentSelectRules.' + rowInfo.index + '.currencies'" label=" " label-width="2px">
            <el-select multiple v-model="item.currencies" placeholder="全部" clearable style="width: 120px;">
              <el-option v-for="v in data.settleCurrencyList" :key="v.value" :label="v.label" :value="v.value" />
            </el-select>
          </el-form-item>
          <span v-else> {{ item.currencies?.length ? item.currencies.join(',') : '全部'}}</span>
        </template>
        <template #wayType="{ item, rowInfo }">
          <el-form-item
            v-if="item.isEdit"
            :prop="'paymentSelectRules.' + rowInfo.index + '.wayType'" label=" " label-width="2px">
            <el-select v-model="item.wayType" placeholder="CARD" style="width: 120px" @change="() => handleWayTypeChange(item)">
              <el-option v-for="v in data.wayTypeList" :key="v.value" :label="v.label" :value="v.value" />
            </el-select>
          </el-form-item>
          <span v-else> {{ item.wayType || 'CARD' }}</span>
        </template>
        <template #cardKinds="{ item, rowInfo }">
          <el-form-item
            v-if="item.isEdit"
            :prop="'paymentSelectRules.' + rowInfo.index + '.cardKinds'" label=" " label-width="2px" :rules="rules.cardKinds">
            <el-select multiple v-model="item.cardKinds" placeholder="全部" no-data-text="暂无数据" style="width: 140px">
              <el-option v-for="v in cardKindsOptions(item.wayType)" :key="v.value" :label="v.label" :value="v.value" />
            </el-select>
          </el-form-item>
          <span v-else> {{ item.cardKindsValue || '全部'}}</span>
        </template>
        <template #minAmount="{ item, rowInfo }">
          <el-form-item
            v-if="item.isEdit"
            :prop="'paymentSelectRules.' + rowInfo.index + '.minAmount'" label=" " label-width="20px" :rules="rules.minAmount">
            <el-input v-model="item.minAmount" placeholder="请输入" style="width: 140px" />
          </el-form-item>
          <span v-else> {{ item.minAmount }}</span>
        </template>
        <template #maxAmount="{ item, rowInfo }">
          <el-form-item
            v-if="item.isEdit"
            :prop="'paymentSelectRules.' + rowInfo.index + '.maxAmount'" label=" " label-width="20px" :rules="rules.maxAmount">
            <el-input v-if="item.isEdit" v-model="item.maxAmount" placeholder="请输入" style="width: 140px" />
          </el-form-item>
          <span v-else> {{ item.maxAmount }}</span>
        </template>
        <template #limitedDailyAmount="{ item, rowInfo }">
          <el-form-item
            v-if="item.isEdit"
            :prop="'paymentSelectRules.' + rowInfo.index + '.limitedDailyAmount'" label=" " label-width="20px" :rules="rules.limitedDailyAmount">
            <el-input v-if="item.isEdit" v-model="item.limitedDailyAmount" placeholder="请输入" style="width: 140px" />
          </el-form-item>
          <span v-else> {{ item.limitedDailyAmount }}</span>
        </template>
        <template #weight="{ item, rowInfo }">
          <el-form-item
            v-if="item.isEdit"
            :prop="'paymentSelectRules.' + rowInfo.index + '.weight'" label=" " label-width="20px" :rules="rules.weight">
            <el-input v-if="item.isEdit" v-model="item.weight" placeholder="请输入" style="width: 140px" />
          </el-form-item>
          <span v-else> {{ item.weight }}</span>
        </template>
        <template #paymentAccountId="{ item, rowInfo }">
          <el-form-item
            v-if="item.isEdit"
            :prop="'paymentSelectRules.' + rowInfo.index + '.paymentAccountId'" label=" " label-width="20px" :rules="rules.paymentAccountId">
            <el-select v-if="item.isEdit" v-model="item.paymentAccountId" placeholder="请选择" no-data-text="暂无数据" style="width: 140px">
              <el-option v-for="v in data.paymentAccountList" :key="v.value" :label="v.label" :value="v.value" />
            </el-select>
          </el-form-item>
          <span v-else> {{ item.paymentAccountName }}</span>
        </template>
        <template #operation="{item, rowInfo}">
          <el-button
            type="primary"
            link
            v-if="!item.isEdit"
            :icon="EditPen"
            title="编辑"
            @click="item.isEdit = true"
          />
          <el-button
            type="primary"
            link
            v-if="item.isEdit"
            :icon="Check"
            title="保存"
            @click="saveTable(item, rowInfo.index)"
          />
          <el-button
            type="primary"
            link
            :icon="Delete"
            title="删除"
            @click="deleteEvent(item, rowInfo.index)"
          />
        </template>
      </tm-table>
      <el-button v-if="canEditAllConfig" type="primary" style="margin-top: 10px;" :icon="Plus" title="新增" @click="addItem" />
      <p class="sub-title" v-if="canViewAllConfig">其他配置</p>
      <div class="flex-box flex-box-other" v-if="canViewAllConfig">
        <el-form-item label="自动发送邮件" prop="autoMail">
          <el-switch active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" style="width: 100px;" v-model="form.autoMail" />
        </el-form-item>
        <el-form-item label="单客户下单次数" prop="autoMail">
          <el-select v-model="form.singleCustomerLimitRule" placeholder="请选择" style="width: 80px">
            <el-option key="DAY" label="每日" value="DAY" />
            <el-option key="MONTH" label="每月" value="MONTH" />
          </el-select>
          <el-input v-model="form.countLimit" placeholder="" style="width: 80px"></el-input> &nbsp;次
        </el-form-item>
        <el-form-item label="A站需要审核" prop="auditSwitch">
          <el-switch active-text="需要" inactive-text="不需要" :active-value="1" :inactive-value="0"
            v-model="form.auditSwitch" />
        </el-form-item>
      </div>
      <div class="flex-box flex-box-other" v-if="canViewAllConfig">
        <el-form-item label="支付页填写账单地址信息" prop="payPageBilling">
          <el-switch active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" style="width: 100px;"
            v-model="form.payPageBilling" />
        </el-form-item>
        <el-form-item label="支付页显示回退图标" prop="showBackIcon">
          <el-switch active-text="是" inactive-text="否" :active-value="1" :inactive-value="0"
            style="width: 215px;"
            v-model="form.showBackIcon" />
        </el-form-item>
      </div>
      <div class="flex-box flex-box-other" v-if="canViewAllConfig">
        <el-form-item prop="failTimesLimit" label="单商户失败次数上限" :rules="[
        {
          required: false,
          message: '请输入',
          trigger: ['blur', 'change'],
        },
        { validator: (rule, value, callback) => checkValue(rule, value, callback, 'number', '请输入正整数'), trigger: ['blur', 'change'] }
      ]">
        <el-input v-model="form.failTimesLimit" placeholder="单商户失败次数上限" style="width: 100px;"></el-input>
        </el-form-item>

        <el-form-item prop="icon" label="支付页品牌图标">
          <file-upload
            @getFiles="val => getFiles(val, 'icon')"
            accept=".png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx,.pdf"
            multiple
            v-if="!form.icon"
            :fileSize="200"
            maxNum="1"
          >
            <el-button type="primary">
              上传
            </el-button>
          </file-upload>
          <div v-else class="img-box">
            <el-image
              style="width: 100px; height: 100px"
              :src="form.icon"
              :zoom-rate="1.2"
              :max-scale="7"
              :min-scale="0.2"
              :preview-src-list="[form.icon]"
              show-progress
              :initial-index="0"
              fit="cover"
            />
            <el-icon @click="form.icon = ''"><CircleCloseFilled /></el-icon>
          </div>
        </el-form-item>
      </div>
      <div class="flex-box flex-box-other" v-if="canViewAllConfig">
        <el-form-item
          v-if="canEditAllConfig && props.record.roleId == 3"
          prop="syncChildConfig" label="">
          <el-checkbox v-model="state.syncChildConfig" style="margin-left: -139px;" :value="true">同步下级商户配置</el-checkbox>
        </el-form-item>
      </div>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleModalClose">取消</el-button>
        <el-button v-if="canEditAllConfig" :loading="btn_loading" type="primary" @click="handleModalOk">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, reactive, onMounted, inject, toRefs, ref } from "vue"
import dialog, { dialogProps } from "@/mixins/dialog"
import { addUser, editUser } from "@/api/systemUser"
import { ElSelect, ElOption } from "element-plus"
import Regulars from '@/utils/validate.js'
import TmTable from "@/components/common/Table.vue"
import { getRoleList } from "@/api/systemRole"
import FileUpload from '@/components/common/FileUpload.vue';
import { fetchCountryList } from "@/utils/countryContinent"
import { CircleCloseFilled, EditPen, Delete, Check, Plus } from "@element-plus/icons-vue"
// import { userTypes } from "../../../const"

const props = defineProps({
  ...dialogProps,
})

const $fetch = inject('$fetch')
const $tm_message_box = inject("$tm_message_box")
const $store = inject('$store')
const ruleForm = ref(null)
const currentRoleId = computed(() => $store.state?.user?.roleId)
const canEditAllConfig = computed(() => [1, 2].includes(currentRoleId.value))
const canViewAllConfig = computed(() => [1, 2].includes(currentRoleId.value))
const canViewFeeConfig = computed(() => [1, 2, 3].includes(currentRoleId.value))
const hasCountryTree = computed(() => {
  const tree = data.countryTree || []
  return tree.some(node => Array.isArray(node.children) && node.children.length > 0)
})

const state = reactive({
  dialogVisible: true,
  syncChildConfig: false,
})

const rules = reactive({
  countryCodes: [
    { required: false, message: '请选择', trigger: 'blur' },
  ],
  cardKinds: [
    { required: false, message: '请选择', trigger: 'blur' },
  ],
  minAmount: [
    { required: true, message: '请输入', trigger: 'blur' },
  ],
  maxAmount: [
    { required: true, message: '请输入', trigger: 'blur' },
  ],
  limitedDailyAmount: [
    { required: true, message: '请输入', trigger: 'blur' },
  ],
  weight: [
    { required: true, message: '请输入', trigger: 'blur' },
  ],
  paymentAccountId: [
    { required: true, message: '请选择', trigger: 'blur' },
  ],
})
const weekOptions = [
  { label: '周一', value: '1' },
  { label: '周二', value: '2' },
  { label: '周三', value: '3' },
  { label: '周四', value: '4' },
  { label: '周五', value: '5' },
  { label: '周六', value: '6' },
  { label: '周日', value: '7' },
]
const formatSettleWeek = (value) => {
  if (!value) return ''
  const arr = Array.isArray(value) ? value : String(value).split(',')
  return arr.map(v => weekOptions.find(item => item.value === v)?.label || v).join(',')
}
const form = reactive({
  banPayment: '',
  banPaymentDesc: '',
  paymentAccountId: '',
  paymentAccountName: '',
  cardKinds: '',
  payTimeout: '',
  oneOrderOnly: 0,
  oneOrderOnlyDesc: '',
  auditSwitch: 0,
  auditSwitchDesc: '',
  mailInterface: '',
  autoMail: 1,
  autoMailDesc: '',
  payPageBilling: 1,
  payPageBillingDesc: '',
  icon: '',
  showBackIcon: '',
  paymentFeeRate: '',
  returnFeeRate: '',
  depositRate: '',
  returnFeePer: 0,
  chargebackFee: 0,
  revolvingMarginDays: 0,
  settleDays: 0,
  singleTradeFee: 0.3,
  failSingleTradeFee: 0.3,
  withdrawFeeRate: '',
  refundPaymentFeeRate: '',
  refundDepositRate: '',
  failTimesLimit: '',
  settleCurrency: '',
  settleFactor: '',
  paymentFactor: 1,
  settleWeek: ['1', '2', '3', '4', '5', '6', '7'],
  paymentSelectRules: [
    {
      countryCodes: [],
      wayType: 'CARD',
      currencies: [],
      cardKinds: [],
      minAmount: 0,
      maxAmount: 0,
      limitedDailyAmount: '',
      weight: 100,
      paymentAccountId: '',
      paymentAccountName: ''
    }
  ],
  singleCustomerLimitRule: '',
  countLimit: '',
  limitedDaily: 0
})
const data = reactive({
  rolesList: [],
  roleIdList: [],
  paymentRuleEnumList: [],
  paymentAccountList: [],
  countries: [],
  countryTree: [],
  settleCurrencyList: [],
  cardTypeList: [],
  walletList: [],
  wayTypeList: [
    { label: 'CARD', value: 'CARD' },
    { label: 'WALLET', value: 'WALLET' },
  ],
  columns: [
    {
      name: "国家",
      value: "countryCodes",
      slot: true,
      width: 200,
      newline: true,
    },
    {
      name: "币种",
      value: "currencies",
      slot: true
    },
    {
      name: "支付方式配置",
      value: "wayType",
      slot: true
    },
    {
      name: "支付种类",
      value: "cardKinds",
      slot: true
    },
    {
      name: "单笔最小",
      value: "minAmount",
      slot: true
    },
    {
      name: "单笔最大",
      value: "maxAmount",
      slot: true
    },
    {
      name: "当日最大",
      value: "limitedDailyAmount",
      slot: true
    },
    {
      name: "权重",
      value: "weight",
      slot: true
    },
    {
      name: "支付账号",
      value: "paymentAccountId",
      slot: true
    },
    {
      name: "操作",
      value: "operation",
      width: 100,
      slot: true,
      newline: true,
    },
  ]
})

let { dialogVisible } = toRefs(state)
const { init_form, btn_loading } = dialog(form)

onMounted(() => {
  getCountryList()
  Promise.all([
    getPaymentAccount().catch(e => { console.warn('[setConfig] getPaymentAccount failed:', e); return null }),
    getCardTypeList().catch(e => { console.warn('[setConfig] getCardTypeList failed:', e); return null }),
    getWalletList().catch(e => { console.warn('[setConfig] getWalletList failed:', e); return null }),
    getCurrencyList().catch(e => { console.warn('[setConfig] getCurrencyList failed:', e); return null })
  ]).then(async () => {
    console.log('wolaile')
    if (props.record.id) {
      await $fetch.get('/system/user/configDetail')({ id: props.record.id }).then(
        res => {
          for (let i in form) {
            form[i] = res.data[i]
          }
          form.singleTradeFee = res.data.singleTradeFee ?? 0.3
          form.failSingleTradeFee = res.data.failSingleTradeFee ?? res.data.singleTradeFee ?? 0.3
          // form.paymentAccountId = form.paymentAccountId?.split(',')
          // if (form.cardKinds !== '') {
          //   form.cardKinds = form.cardKinds?.split(',')
          // }
          res.data.paymentSelectRules?.forEach(item => {
            item.wayType = item.wayType || 'CARD'
            item.currencies = Array.isArray(item.currencies) ? item.currencies : (item.currencies ? String(item.currencies).split(',') : [])
            if (!item.currencies?.length && item.currency) {
              item.currencies = [item.currency]
            }
            item.countryCodes = Array.isArray(item.countryCodes) ? item.countryCodes : (item.countryCodes ? String(item.countryCodes).split(',') : [])
            item.cardKinds = Array.isArray(item.cardKinds) ? item.cardKinds : (item.cardKinds ? String(item.cardKinds).split(',') : [])

            let cardKinds = cardKindsOptions(item.wayType).filter(v => item.cardKinds.includes(v.value))
            item.cardKindsValue = cardKinds.map(v => v.label).join(',')

            let countryCodesList = (data.countries && data.countries.length) ? data.countries.filter(v => item.countryCodes.includes(v.shortName)) : []
            item.countryValue = countryCodesList.length ? countryCodesList.map(v => v.name).join(',') : (item.countryCodes?.length ? item.countryCodes.join(',') : '全部')

            let paymentAccountId = data.paymentAccountList.find(v => item.paymentAccountId == v.value)
            console.log(paymentAccountId, item.paymentAccountId, data.paymentAccountList, 'paymentAccountId')
            item.paymentAccountName = paymentAccountId?.label
            item.paymentAccountId = item.paymentAccountId.toString()
            // item.paymentAccountName = 
          })
          form.paymentSelectRules = res.data.paymentSelectRules || []
          form.failTimesLimit = form.failTimesLimit || 3
          form.settleWeek = form.settleWeek ? String(form.settleWeek).split(',') : weekOptions.map(v => v.value)
          
        },
        () => {
        }
      )
    } else {
      form.paymentSelectRules = []
    }
  })
})

const getPaymentAccount = () => {
  const params = {
    type: 'paymentAccount',
    ext: { scene: 'available' }
  }
  return $fetch.post('/base/select')(params)
    .then(res => {
      data.paymentAccountList = res.data || []
    })
}

const getCardTypeList = () => {
  const params = {
    type: 'CardTypeEnum'
  }
  return $fetch.post('/base/select')(params)
    .then(res => {
      data.cardTypeList = res.data || []
    })
}

const getWalletList = () => {
  const params = {
    type: 'WalletEnum'
  }
  return $fetch.post('/base/select')(params)
    .then(res => {
      data.walletList = res.data || []
    })
}

const cardKindsOptions = (wayType) => {
  return wayType === 'WALLET' ? data.walletList : data.cardTypeList
}

const handleWayTypeChange = (item) => {
  if (!item) return
  item.cardKinds = []
  item.cardKindsValue = ''
}

const handleDecimalInput = (value, val) => {
  // 只允许输入小数，且最多4位小数
  const regex = /^(\d+)?(\.\d{0,4})?$/;
  if (regex.test(value) || value === '') {
    this.form[val] = value;
  } else {
    // 若非法输入则还原为之前值（可选）
    this.form.paymentFeeRate = this.form.paymentFeeRate || '';
  }
}

// 校验
const checkValue = (rule, value, callback, type, msg) => {
  if (!Regulars[type].test(value)) {
    callback(new Error(msg || `请输入正确的内容`))
  } else {
    callback()
  }
}

const handleModalOk = () => {
  if ($store.state?.user?.roleId > 2) {
    delete form.paymentAccountId
  }
  ruleForm.value.validate(valid => {
    if (valid) {
      let url = '', params = {}
      let temp = JSON.parse(JSON.stringify(form))
      temp.settleWeek = Array.isArray(temp.settleWeek) ? temp.settleWeek.join(',') : temp.settleWeek
      
      if (props.record.id) {
        url = '/system/user/configDetail/save'
        params = {
          config: temp,
          syncChildConfig: state.syncChildConfig,
          id: props.record.id
        }
      } else {
        url = '/system/user/configDetail/saveBatch'
        params = {
          config: temp,
          syncChildConfig: state.syncChildConfig,
          ids: props.record.ids.map(Number)
        }
      }
      console.log(params, 'pa')

      $fetch.post(url)(params).then(
        () => {
          $tm_message_box.toast(`操作成功`, { type: "success" })
          props.ok()
        },
        () => {
        }
      )
    }
  })
}

const handleModalClose = () => {
  dialogVisible = false
  props.close()
}

// 系数 正则
const checkFactor = (rule, value, callback) => {
  console.log(value, '123')
  if (!/^(1(\.\d{1,4})?|2(\.0{1,4})?)$/.test(value)) {
    callback(new Error("系数必须为1到2之间的小数，最多4位小数"))
  } else {
    callback()
  }
}

const checkPaymentFactor = (rule, value, callback) => {
  if (value === '' || value === null || value === undefined) {
    callback(new Error('请输入支付系数'))
    return
  }
  if (!/^\d+(\.\d+)?$/.test(String(value))) {
    callback(new Error('支付系数必须为数字'))
    return
  }
  const num = Number(value)
  if (Number.isNaN(num) || num < 1 || num > 1.1) {
    callback(new Error('支付系数必须大于等于1且小于等于1.1'))
    return
  }
  callback()
}


const getCurrencyList = () => {
  const params = {
    type: 'currency',
  }
  return $fetch.post('/base/select')(params).then(res => {
    data.settleCurrencyList = res.data
  })
}


const getFiles = (val, label) => {
  console.log(val)
  form[label] = val.filePath
}

const getCountryList = async () => {
  const result = await fetchCountryList($fetch, (level, msg, info) => {
    if (level === 'warn') {
      console.warn('[setConfig] ' + msg, info)
      return
    }
    console.log(
      '[setConfig] ' + msg,
      (info && info.countries) || 0,
      'tree leaf country nodes:',
      (info && info.leafCount) || 0,
      'hasCountryTree =>',
      !!(info && info.hasCountryTree)
    )
    if (info) {
      if (info.countryTreeSample && info.countryTreeSample.length) {
        console.log('[setConfig] countryTree sample (first 2 nodes):', JSON.stringify(info.countryTreeSample, null, 2))
      }
      if (info.firstCountrySample) {
        console.log('[setConfig] data.countries first item keys sample:', Object.keys(info.firstCountrySample), 'sample value:', JSON.stringify(info.firstCountrySample))
      }
      if (!info.hasCountryTree) {
        console.warn('[setConfig] countryTree has no leaf nodes, will fall back to flat country select (countryCodes column). first item keys:', Object.keys((info && info.firstCountrySample) || {}))
      }
    }
  })
  data.countries = result.countries || []
  data.countryTree = result.countryTree || []
}

const deleteEvent = (item, index) => {
  form.paymentSelectRules.splice(index, 1)
}

const saveTable = (item, index) => {
  console.log(index, 'paymentSelectRules.' + index + '.minAmount', ruleForm.value)
  item.countryCodes = (item.countryCodes || []).filter(v => !v.startsWith('continent_'))
  ruleForm.value?.validateField([
    'paymentSelectRules.' + index + '.countryCodes', 
    'paymentSelectRules.' + index + '.wayType', 
    'paymentSelectRules.' + index + '.cardKinds', 
    'paymentSelectRules.' + index + '.minAmount', 
    'paymentSelectRules.' + index + '.maxAmount', 
    'paymentSelectRules.' + index + '.limitedDailyAmount',
    'paymentSelectRules.' + index + '.weight',
    'paymentSelectRules.' + index + '.paymentAccountId'], (valid) => {
    console.log(valid, 'valid1')
    if (valid) {
      console.log('eolaile')
      item.isEdit = false
      item.wayType = item.wayType || 'CARD'
      let cardKinds = cardKindsOptions(item.wayType).filter(v => item.cardKinds.includes(v.value))
      item.cardKindsValue = cardKinds.map(v => v.label).join(',')

      let countryCodes = data.countries.filter(v => item.countryCodes.includes(v.shortName))
      item.countryValue = countryCodes.map(v => v.name).join(',')

      let paymentAccountId = data.paymentAccountList.find(v => item.paymentAccountId == v.value)
      item.paymentAccountName = paymentAccountId?.label
    } else {

    }
  })
  
  // item.paymentAccountName = ''
}

const addItem = () => {
  let value = (form.paymentSelectRules || []).map(v => v.weight).reduce((pre, cur) => Number(pre) + Number(cur), 0)
  console.log(value, 'value')
  let weight = (100 - value) > 0 ? (100 - value) : 0
  let item = {
    countryCodes: [],
    currencies: [],
    wayType: 'CARD',
    cardKinds: [],
    minAmount: 0,
    maxAmount: 0,
    limitedDailyAmount: '',
    weight: weight,
    paymentAccountId: '',
    paymentAccountName: '',
    isEdit: true
  }
  form.paymentSelectRules.push(item)
}
</script>

<style lang="less" scoped>
.form {
  .el-form-item {
    display: block;

    .el-form-item__label {
      justify-content: flex-start;
    }
  }
}
.flex-box {
  display: flex;
  gap: 10px;
}
.flex-box-fee{
  // :deep(.el-form-item) {
  //   width: 330px;
  // }
  // :deep(.el-form-item__label) {
  //   width: 180px !important;
  // }
}
.flex-box-settle, .flex-box-ban {
  :deep(.el-form-item__label) {
    width: 170px !important;
  }
}
.flex-box-other {
  :deep(.el-form-item) {
    width: 350px;
  }
}
.sub-title {
  font-weight: 600;
  font-size: 18px;
  margin: 16px 0;
}
:deep(.el-table__empty-block) {
  .el-empty {
    display: none;
  }
  .el-table__empty-text {
    &::before {
      content: '暂无数据';
    }
  }
}

.img-box {
  position: relative;
  i {
    position: absolute;
    top: -4px;
    right: -4px;
    font-size: 20px;
    cursor: pointer;
  }
}
.flex-box-other {
  :deep(.el-form-item__content) {
    align-items: flex-start;
  }
}
.table-ref {
  :deep(.el-form-item__label) {
    padding: 0;
  }
  :deep(.el-form-item) {
    margin-bottom: 0;
  }
}
.settle-week-select {
  :deep(.el-select__tags .el-tag) {
    flex-basis: 100%;
    max-width: 100%;
  }
}
.settle-week-form-item {
  width: 562px;
}
</style>
